import { BusinessError, type ApiResponse } from '@/api/envelope';
import { api } from '@/services';
import type { ObterNfseResponse } from '../types';
import { consultaDoContribuinte } from './consultaDoContribuinte';

/**
 * O detalhe da NFS-e. A rota nativa responde no envelope de sempre (`{ data, status }`); a tela lia os campos fora
 * do envelope, como no legado, e por isso mostrava o detalhe vazio. Nota que não é do gestor (SPEC-011) volta com
 * `resultado: false` e a mensagem da API.
 */
export async function fetchObterNfse(
  chaveAcessoDoc: string,
  cnpjContribuinte?: string | null
): Promise<ObterNfseResponse> {
  const resposta = await api.get<ApiResponse<ObterNfseResponse | null>>(
    `Documento/ObterNFS/${encodeURIComponent(chaveAcessoDoc)}${consultaDoContribuinte(cnpjContribuinte)}`
  );

  if (resposta?.status?.resultado === false || !resposta?.data) {
    throw new BusinessError(resposta?.status?.mensagem || 'Documento não encontrado.');
  }

  return resposta.data;
}
